module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "eve-of-warfare-1.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This book is a work of fiction. All names, characters, locations, and incidents are products of the author’s imagination, or have been used fictitiously. Any resemblance to actual persons living or dead, locales, or events is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("EVE OF WARFARE")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2010 by Sylvia Day")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Edited by Trisha Telep.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Cover design by Croco Designs.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Interior design by VMC Art & Design, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Published by Sylvia Day, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("5130 S. Fort Apache Rd.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Ste. #215-447")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Las Vegas, NV 8918")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sylviaday.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sylviaday.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The uploading, scanning, and distribution of this book in any form or by any means—including but not limited to electronic, mechanical, photocopying, recording, or otherwise—without the permission of the copyright holder is illegal and punishable by law. Please purchase only authorized editions of this work, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 978-0-9828571-3-7")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a0e9104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eveofwarfare1.vue
// module id = 66
// module chunks = 0